export class  DizionarioModel {
    id?:number;
    codice?:string;
    descrizione?:string;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/shared/dizionario.model.ts